import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"

class Ranking extends Component {
  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <div className="ranking card card--pd-md">
          <div className="ranking__rank">
            {blok.rank && <p className="ranking__rank-number">{blok.rank}</p>}
            {blok.rank_type && (
              <p
                className={`ranking__rank-type ${
                  blok.rank_type === "#" ? "ranking__rank-type--hash" : ""
                }`}
              >
                {blok.rank_type}
              </p>
            )}
          </div>
          <div className="ranking__copy">
            {blok.title && <p className="ranking__copy-title">{blok.title}</p>}
            {blok.description && (
              <div className="ranking__description">
                {
                  unified()
                    .use(remarkParse)
                    .use(remarkRehype)
                    .use(rehypeReact, {
                      createElement: React.createElement,
                      components: remarkReactComponents,
                      Fragment: React.Fragment,
                    })
                    .processSync(blok.description).result
                }
              </div>
            )}
          </div>
        </div>
      </SbEditable>
    )
  }
}

Ranking.propTypes = {
  blok: PropTypes.shape({
    rank_type: PropTypes.string,
    rank: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}

export default Ranking
